<template>
    <div class="kanban-container" ref="kanban">
        <div style="height:60px;display:flex;">

            <img style="height:30px;margin: 15px 70px 15px 90px;" :src="require('../../assets/p-kb-1.png')" />
            <span class="production-kb-header">【{{ companyName }}】库存实时看板</span>
            <img style="height:30px;margin-top:15px;margin-left: 75px;" :src="require('../../assets/p-kb-1.png')" />

        </div>

        <div style="overflow: auto;height: 570px;">
            <table class="kb-table">
                <tr style="font-size: larger;">
                    <td style="width: 35px;max-width: 35px;">产品名称</td>
                    <td style="width: 15px;max-width: 15px;">来料数</td>
                    <td style="width: 15px;max-width: 15px;">日期</td>
                    <td style="width: 15px;max-width: 15px;">出货数</td>
                    <td style="width: 13px;max-width: 13px;">颜色</td>

                    <td style="width: 15px;max-width: 15px;">日期</td>
                    <td style="width: 15px;max-width: 15px;">退胚数</td>
                    <td style="width: 15px;max-width: 15px;">欠数</td>

                    <td style="width: 4px;max-width: 4px;">-</td>
                    <td style="width: 35px;max-width: 35px;">产品名称</td>
                    <td style="width: 15px;max-width: 15px;">来料数</td>
                    <td style="width: 15px;max-width: 15px;">日期</td>
                    <td style="width: 15px;max-width: 15px;">出货数</td>
                    <td style="width: 13px;max-width: 13px;">颜色</td>

                    <td style="width: 15px;max-width: 15px;">日期</td>
                    <td style="width: 15px;max-width: 15px;">退胚数</td>
                    <td style="width: 15px;max-width: 15px;">欠数</td>
                </tr>

                <tr v-for="(item, index) in prodStockKanbanList" :key="index">

                    <td style="text-align:left;padding-left:5px;" v-html="item.productName"></td>
                    <td>{{ item.inQuantity }}</td>
                    <td>{{ item.inTime }}</td>

                    <td>{{ item.outQuantity }}</td>
                    <td>{{ item.remark }}</td>

                    <td>{{ item.outTime }}</td>
                    <td>{{ item.returnQuantity }}</td>
                    <td>{{ item.stockQuantity }}</td>

                    <td></td>
                    <td style="text-align:left;padding-left:5px;" v-html="item.productNameTwo"></td>
                    <td>{{ item.inQuantityTwo }}</td>
                    <td>{{ item.inTimeTwo }}</td>

                    <td>{{ item.outQuantityTwo }}</td>
                    <td>{{ item.remarkTwo }}</td>

                    <td>{{ item.outTimeTwo }}</td>
                    <td>{{ item.returnQuantityTwo }}</td>
                    <td>{{ item.stockQuantityTwo }}</td>
                </tr>

            </table>

            <div style="height: 10px;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div style="height: 10px;"></div>

        <div style="position: absolute;right: 30px;bottom: 5px;">
            <i class="el-icon-full-screen" @click="fullScreen" style="color:orange"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            companyId: '',
            companyName: '中国制造',

            prodStockKanbanList: [],

            index: 0,
            statusSearch: 0,

            pageIndex: 0,
            pageNum: 18,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        getAll() {

            this.$axios({
                method: "get",
                url: "/shiro/product/stock/kb/tv?companyId=" + this.companyId + '&pageIndex=' + this.pageIndex,
                data: {},
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                this.prodStockKanbanList = data.data

                this.total = this.prodStockKanbanList[0].total

                for (let i in this.prodStockKanbanList) {
                    
                    this.prodStockKanbanList[i].inTime = this.$moment(this.prodStockKanbanList[i].inTime).format("YYYY-MM-DD")
                    this.prodStockKanbanList[i].outTime = this.$moment(this.prodStockKanbanList[i].outTime).format("YYYY-MM-DD")

                    this.prodStockKanbanList[i].inTimeTwo = this.$moment(this.prodStockKanbanList[i].inTimeTwo).format("YYYY-MM-DD")
                    this.prodStockKanbanList[i].outTimeTwo = this.$moment(this.prodStockKanbanList[i].outTimeTwo).format("YYYY-MM-DD")

                }

            })
        },
        
        fullScreen() {
            // console.log('fullScreen')
            let element = this.$refs.kanban
            // console.log(element)

            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        }
    },
    mounted() {

        let url = window.location.href
        // console.log('url')
        // console.log(url)

        let str = url.substring(url.indexOf('?') + 1)
        let arrs = str.split('&')
        let result = {};

        arrs.forEach(item => {
            let keyArr = item.split('=')
            let name = keyArr[0]
            let value = keyArr[1]
            result[name] = value
        })

        if (Object.keys(result).length >= 1) {
            // console.log(result)
            // console.log('result.cid')
            // console.log(result.cid)
            this.companyId = result.cid
            this.pageIndex = result.p * this.pageNum
        }

        this.getAll()

        this.$axios({
            method: "post",
            url: "/shiro/company/getKb",
            data: {
                id: this.companyId
            }, headers: {
                token: this.token
            }
        }).then(result => {
            this.companyName = result.data.data.companyName
        })

        setInterval(() => {
            this.getAll()
        }, 60000)

    },
    updated() {
        var ele = document.getElementsByClassName('el-progress-bar__inner')

        // console.log('upp')
        // console.log(ele)
        for (let i in ele) {
            var str = ele[i].attributes.style.value
            // console.log(str)
            var s = str.indexOf(':')
            var e = str.indexOf('%')

            var w = str.substring(s + 1, e)
            // console.log('---')
            // console.log(s)
            if (parseInt(w) > 100) {
                // console.log('>100')
                ele[i].attributes.style.value = 'width:100%'
            }
        }

    }
}
</script>

<style>
.kanban-container {
    width: 100%;
    height: 600px;
    background-color: #06207D;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    position: relative;
}

.production-kb-header {
    font-size: 25px;
    font-weight: bolder;
    color: white;
    line-height: 60px;
}

.kb-table {
    width: 1000px;
    table-layout: fixed;
    border: 1px solid white;
    font-size: 13px;
    font-weight: bold;
    color: white;
    border-collapse: collapse;
    border-spacing: 1px;
}

.kanban-tr-odd {
    font-size: 9px;
    color: black;
    background-color: white;
}

.kanban-tr {
    font-size: 9px;
    color: black;
    background-color: greenyellow;
}

.kb-table td {
    border: 1px solid #e5e7eb;
    padding: 0;
}

.kanban-td-o {
    background-color: orange;
}

.kanban-td-g {
    background-color: green;
}

.kanban-td-r {
    background-color: red;
}

.kanban-tr-odd td,
.kanban-tr td {
    border: 1px solid black;
}

div::-webkit-scrollbar {
    background: #6f5499;
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

div::-webkit-scrollbar-thumb {
    background: orange;
    border-radius: 10px;

}

.el-pagination__total {
    color: pink;
}
</style>